import React, { useContext } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import Context from "../../Context";
import { Link } from "react-router-dom";
import HeaderArea from "./Header/HeaderArea";
import UserNav from "./UserNav";

function UserMenu() {
  const cx = useContext(Context);

  let show = cx.user.show || {};
  return (
    <OffCanvas toggleFunction={cx.userMenuToggle} on={cx.userMenuIsExpanded}>
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <UserGreeting show={show} toggleFunction={cx.userMenuToggle} />
        {cx.isMobile ? <UserContexts /> : null}
        <div className="offcanvas-content pr-5 mr-n5">
          <UserInfo show={show} logoutFunction={cx.user.logout} />
          <div className="separator separator-dashed mt-8 mb-5"></div>
          <UserNav toggleFunction={cx.userMenuToggle} />
          <div className="separator separator-dashed mt-8 mb-5"></div>
        </div>
      </PerfectScrollbar>
    </OffCanvas>
  );
}

function UserContexts() {
  return (
    <>
      <div className="separator separator-dashed mt-2 mb-5"></div>
      <HeaderArea />
      <div className="separator separator-dashed mt-5 mb-2"></div>
    </>
  );
}

function UserGreeting(props) {
  const cx = useContext(Context);
  let arNotifyLine = [];
  if (cx.notifier.task.enabled) {
    arNotifyLine.push(`${cx.notifier.task.enabled} задач`);
  }
  if (cx.notifier.notice.notice) {
    arNotifyLine.push(`${cx.notifier.notice.notice} уведомлений`);
  }
  return (
    <>
      <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
        <h3 className="font-weight-bold m-0">
          Здравствуйте, {props.show.hello}
          <br />
          <small className="text-muted font-size-sm ml-2">
            {arNotifyLine.length > 0 ? (
              <> У вас {arNotifyLine.join(", ")}</>
            ) : (
              <>Добро пожаловать</>
            )}
          </small>
        </h3>
        <button
          onClick={props.toggleFunction}
          className="btn btn-xs btn-icon btn-light btn-hover-primary"
        >
          <i className="flaticon2-cross text-muted icon-xs"></i>
        </button>
      </div>
    </>
  );
}

function UserInfo(props) {
  const cx = useContext(Context);
  let adminLabel = props.show.admin ? (
    <div className="mt-2">
      <Link to="/admin/" onClick={cx.userMenuToggle}>
        <span className="label label-success label-inline ">Администратор</span>
      </Link>
    </div>
  ) : null;

  const { passwordchange } = cx.user.info.profile;

  return (
    <div>
      <div className="d-flex align-items-center mt-5">
        <div className="mr-5">
          <Link to="/profile/" onClick={cx.userMenuToggle}>
            <div className="symbol symbol-100 ">
              {props.show.picture ? (
                <img alt="userpic" src={props.show.picture} />
              ) : (
                <span className="symbol-label font-size-h1">
                  {props.show.literal}
                </span>
              )}

              {passwordchange && <i className="symbol-badge bg-warning"></i>}
            </div>
          </Link>
          {adminLabel}
        </div>

        <div className="">
          <Link
            onClick={cx.userMenuToggle}
            to="/profile/"
            className="d-block font-weight-bold font-size-h6 text-dark-75 text-hover-primary"
          >
            {props.show.name}
          </Link>

          {props.show.department && (
            <span className="small  label-inline text-dark-50 mt-1 mr-1">
              {props.show.department}
            </span>
          )}
          {props.show.role && (
            <span className="label label-inline mt-1">{props.show.role}</span>
          )}
          <div className="navi mt-2">
            {passwordchange && (
              <Link
                onClick={cx.userMenuToggle}
                title="Профиль"
                to="/profile/"
                className="btn btn-sm btn-icon btn-light-warning mr-2 pulse pulse-warning"
              >
                <span className="pulse-ring"></span>
                <i className="fa fa-key"></i>
              </Link>
            )}

            {!passwordchange && (
              <Link
                onClick={cx.userMenuToggle}
                title="Профиль"
                to="/profile/"
                className="btn btn-sm btn-icon btn-light-primary mr-2"
              >
                <i className="fa fa-pencil-square-o"></i>
              </Link>
            )}

            <button
              title="Завершить сеанс"
              onClick={props.logoutFunction}
              className="btn btn-sm btn-icon btn-light-primary  mr-2"
            >
              <i className="fa fa-power-off"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function OffCanvas(props) {
  const classes = ["offcanvas", "offcanvas-right", "p-10"];
  const overlay = props.on ? (
    <div onClick={props.toggleFunction} className="offcanvas-overlay"></div>
  ) : null;
  if (props.on) classes.push("offcanvas-on");
  return (
    <>
      <div className={classes.join(" ")}>{props.children}</div>
      {overlay}
    </>
  );
}

export default UserMenu;
